import { useCompositionAdvancedOptionsContext } from 'features/compositions/context/CompositionAdvancedOptionsContext';
import styles from './CompositionOperators.module.css';

const CompositionOperators = () => {
    const { operator, setOperator } = useCompositionAdvancedOptionsContext();

    return (
        <fieldset className={styles.composition_operators}>
            <div className={styles.operator}>
                <div className={styles.radio_thumb}>
                    <input
                        type="radio"
                        id="intersection"
                        name="operator"
                        value="&&"
                        checked={operator === "&&"}
                        onChange={(e) => setOperator(e.target.value)}
                    />
                </div>
                <label htmlFor="intersection">Intersection</label>
            </div>

            <div className={styles.operator}>
                <div className={styles.radio_thumb}>
                    <input
                        type="radio"
                        id="union"
                        name="operator"
                        value="||"
                        checked={operator === "||"}
                        onChange={(e) => setOperator(e.target.value)}
                    />
                </div>
                <label htmlFor="union">Union</label>
            </div>
        </fieldset>
    )
}

export default CompositionOperators;
